import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth';
import { uploadAttachment, deleteAttachment } from './api';
import type { UploadAttachmentResponse } from './schemas';

function useActiveTenantId(): string {
  const tenantId = useAuthStore((s) => s.tenantUser?.tenantId);
  if (!tenantId) throw new Error('useActiveTenantId called without an active tenant');
  return tenantId;
}

export function useUploadAttachment(options?: { embedSync?: boolean }) {
  const tenantId = useActiveTenantId();
  return useMutation<UploadAttachmentResponse, Error, { file: File }>({
    mutationFn: ({ file }) => uploadAttachment(tenantId, file, options),
  });
}

export function useDeleteAttachment() {
  const tenantId = useActiveTenantId();
  return useMutation<void, Error, { id: string }>({
    mutationFn: ({ id }) => deleteAttachment(tenantId, id),
  });
}
